import { updateUserInfo } from "actions/userActions"
import CarrotClient from "lib/carrot-api"
import { useQuery, UseQueryResult } from "react-query"
import { useDispatch } from "react-redux"
import { AboutYou } from "types/carrotPlanTypes"
import ResponseError from "types/responseError"
import Settings from "utils/CarrotConfig"
import { HttpStatusCodes } from "utils/HttpStatusCodes"
import { useState } from "react"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetAboutYou"

type UseCarrotPlanReturn = UseQueryResult<AboutYou, ResponseError> & {
  hasQuestionBeenSkipped: (questionKey: string) => boolean
  updateAboutYou: (data: AboutYou) => Promise<void>
  continueLoading: boolean
}

export default function useAboutYou(): UseCarrotPlanReturn {
  const dispatch = useDispatch()
  const [continueLoading, setContinueLoading] = useState(false)
  const aboutYouQuery = useQuery<AboutYou, ResponseError>([ENDPOINT], () => client.getAboutYou(), {
    retry: (failureCount, error) => {
      switch (error.statusCode) {
        case HttpStatusCodes.UNAUTHORIZED:
        case HttpStatusCodes.BAD_REQUEST:
        case HttpStatusCodes.NOT_FOUND:
          return false
        default:
          return failureCount <= 3
      }
    }
  })
  function hasQuestionBeenSkipped(questionKey: string): boolean {
    return aboutYouQuery.data?.skipFields.includes(questionKey)
  }
  async function updateAboutYou(data: AboutYou): Promise<void> {
    const { address, ...otherData } = data
    let spreadAddress = {}
    if (address) {
      spreadAddress = data.address
    }
    if (!continueLoading) {
      setContinueLoading(true)
      await dispatch(updateUserInfo({ ...otherData, ...spreadAddress }))
      setContinueLoading(false)
    }
  }
  return {
    ...aboutYouQuery,
    updateAboutYou,
    hasQuestionBeenSkipped,
    continueLoading
  }
}
